
import { useEffect, useState } from 'react'
import './style.scss'
import { userStateData } from '../../data/userStateData'
import { useAppSelector } from '../../redux/hooks'
import LabeledInput from '../../components/labeledInput/LabeledInput'
import LabeledDropDown from '../../components/labeledDropDown/LabeledDropDown'
import { INSTRUCTOR_GENDERS, LANGUAGES } from '../../constants/searchConstants'
import { DOCUMENT_FILE_PATH, PROFILE_PIC_URL } from '../../constants/pathConstants'
import { updateConnector } from '../../server/connector/updateConnector'
import CtaButton from '../../components/ctaButton/CtaButton'
import { TERRAINS } from '../../constants/searchConstants'
import { AccountStatus } from '../../types/types'
import LabeledTextArea from '../../components/labeledTextArea/LabeledTextArea'

const BANK_COUNTRIES: string[] = ['UK', 'New Zealand']
const MAX_PRICES: number[] = [0, 40, 55, 70, 85]

const STATUS_OPTIONS: string[] = [
	AccountStatus.ACTIVE,
	AccountStatus.VERIFY_EMAIL,
	AccountStatus.ID_NOT_PROVIDED,
	AccountStatus.CERTIFICATE_NOT_PROVIDED,
	AccountStatus.CERTIFICATE_UNDER_REVIEW,
	AccountStatus.AWAITING_PROOF,
	AccountStatus.INCOMPLETE,
	AccountStatus.FLAGGED,
	AccountStatus.DISABLED,
	AccountStatus.SUSPENDED,
	AccountStatus.BANNED,
	AccountStatus.FULLY_BOOKED
]

function AdminInstructorProfileContentArea() {
	const [userDataLoaded, setUserDataLoaded] = useState<boolean>(false)

	const dataLoadRequestFinished: boolean = useAppSelector(state => state.user.dataLoadRequestFinished)

	const [profilePicUrls, setProfilePicUrls] = useState<string[] | undefined>(undefined)
	const [yourName, setYourName] = useState<string>('')
	const [accountStatus, setAccountStatus] = useState<string>()
	const [country, setCountry] = useState<string>('')
	const [phoneNumber, setPhoneNumber] = useState<string>('')
	const [gender, setGender] = useState<string | undefined>(undefined)
	const [level, setLevel] = useState<string | undefined>(undefined)
	const [aboutText, setAboutText] = useState<string | undefined>(undefined)
	// const [dobDate, setDobDate] = useState<number | undefined>(undefined)
	// const [dobMonth, setDobMonth] = useState<number | undefined>(undefined)
	// const [dobYear, setDobYear] = useState<number | undefined>(undefined)
	const [dobDate, setDobDate] = useState<string | undefined>(undefined)
	const [dobMonth, setDobMonth] = useState<string | undefined>(undefined)
	const [dobYear, setDobYear] = useState<number | undefined>(undefined)

	const [price, setPrice] = useState<string | undefined>(undefined)

	const [languages, setLanguages] = useState<string | undefined>(undefined)
	const [terrains, setTerrains] = useState<string | undefined>(undefined)

	const [idFilePath, setIdFilePath] = useState<string | undefined>(undefined)
	const [certificateFilePath, setCertificateFilePath] = useState<string | undefined>(undefined)

	const [bankName, setBankName] = useState<string | undefined>(undefined)
	const [account, setAccount] = useState<string | undefined>(undefined)
	const [sortCode1, setSortCode1] = useState<string | undefined>(undefined)
	const [sortCode2, setSortCode2] = useState<string | undefined>(undefined)
	const [sortCode3, setSortCode3] = useState<string | undefined>(undefined)
	const [swiftBic, setSwiftBic] = useState<string | undefined>(undefined)
	const [bankCountry, setBankCountry] = useState<string | undefined>(undefined)

	const [updatingUserData, setUpdatingUserData] = useState<boolean>(false)

	const [valueChanged, setValueChanged] = useState<boolean>(false) // flag indicating if values have changed to disable update button

	const MIN_PRICE: number = 0
	// const MAX_PRICE: number = 40
	// const MAX_PRICE_2: number = 55
	// const MAX_PRICE_3: number = 70
	// const MAX_PRICE_4: number = 85

	// Setup test values
	useEffect(() => {
		if (dataLoadRequestFinished === true) {
			updateUserValues()
			setUserDataLoaded(true)
		}
	}, [dataLoadRequestFinished])

	const updateUserValues = () => {
		// setYourName(userStateData.getUsersName())
		// setCountry(userStateData.getCountry())
		// setAccountStatus(userStateData.getStatus())
		// setPhoneNumber(userStateData.getPhoneNumber())
		// setGender(userStateData.getGender())
		// setLevel(userStateData.getLevel())
		// setAboutText(userStateData.getAboutText())
		// setLanguages(userStateData.getLanguages())
		// setTerrains(userStateData.getTerrains())

		// const currentDob: string | undefined = userStateData.getDob()
		// if (currentDob) {
		// 	const dob: Date = new Date(currentDob)
		// 	setDobDate(dob.getDate())
		// 	setDobMonth(dob.getMonth() + 1)
		// 	setDobYear(dob.getFullYear())
		// }

		// setBankName(userStateData.getBankName())
		// setBankName(userStateData.getBankName())
		// setAccount(userStateData.getBankAccountNumber())
		// const sortCodeStr: string | undefined = userStateData.getBankSortCode()
		// if (sortCodeStr) {
		// 	const splitCodes: string[] = sortCodeStr.split('-')
		// 	if (splitCodes.length === 3) {
		// 		setSortCode1(splitCodes[0])
		// 		setSortCode2(splitCodes[1])
		// 		setSortCode3(splitCodes[2])
		// 	}
		// }
		// setSwiftBic(userStateData.getBankSwiftBic())

		// setCertificateFilePath(userStateData.getCertificateFilePath())
		// setIdFilePath(userStateData.getIdFilePath())
		// setProfilePicUrls(userStateData.getSplitProfilePics())
		setYourName(userStateData.getUsersName())
		setCountry(userStateData.getCountry())
		setAccountStatus(userStateData.getStatus())

		setPhoneNumber(userStateData.getPhoneNumber())
		setGender(userStateData.getGender())
		// setLevel(userStateData.getLevel())
		setLevel(userStateData.getLevel())
		setAboutText(userStateData.getAboutText())
		setLanguages(userStateData.getLanguages())
		setTerrains(userStateData.getTerrains())
		setPrice(userStateData.getPrice())

		const currentDob: string | undefined = userStateData.getDob()
		// if (currentDob) {
		// 	const dob: Date = new Date(currentDob)
		// 	setDobDate(dob.getDate())
		// 	setDobMonth(dob.getMonth() + 1)
		// 	setDobYear(dob.getFullYear())
		// }
		if (currentDob) {
			// // const dob: Date = new Date(currentDob)
			// // setDobDate(dob.getDate() < 10 ? `0${dob.getDate()}` : `${dob.getDate()}`)
			// // // setDobMonth(dob.getMonth() + 1)
			// // setDobMonth(dob.getMonth() + 1 < 10 ? `0${dob.getMonth() + 1}` : `${dob.getMonth() + 1}`)
			// // setDobYear(dob.getFullYear())
			// // const dob: Date = new Date(currentDob)
			// setDobDate(currentDob.split('-')[0])
			// // setDobMonth(dob.getMonth() + 1)
			// setDobMonth(currentDob.split('-')[1])
			// setDobYear(Number(currentDob.split('-')[2]))
			const dob: Date = new Date(currentDob)
			setDobDate(dob.getDate() < 10 ? `0${dob.getDate()}` : `${dob.getDate()}`)
			// setDobMonth(dob.getMonth() + 1)
			setDobMonth(dob.getMonth() + 1 < 10 ? `0${dob.getMonth() + 1}` : `${dob.getMonth() + 1}`)
			setDobYear(dob.getFullYear())
			// setDobDate(currentDob.split('-')[0])
			// // setDobMonth(dob.getMonth() + 1)
			// setDobMonth(currentDob.split('-')[1])
			// setDobYear(Number(currentDob.split('-')[2]))
		}

		setBankCountry(userStateData.getBankCountry())
		setBankName(userStateData.getBankName())
		setAccount(userStateData.getBankAccountNumber())
		const sortCodeStr: string | undefined = userStateData.getBankSortCode()
		if (sortCodeStr) {
			const splitCodes: string[] = sortCodeStr.split('-')
			if (splitCodes.length === 3) {
				setSortCode1(splitCodes[0])
				setSortCode2(splitCodes[1])
				setSortCode3(splitCodes[2])
			}
		}
		setSwiftBic(userStateData.getBankSwiftBic())

		setCertificateFilePath(userStateData.getCertificateFilePath())
		setIdFilePath(userStateData.getIdFilePath())
		setProfilePicUrls(userStateData.getSplitProfilePics())
	}

	const yourNameOnChange = (newValue: string) => {
		setYourName(newValue)
		setValueChanged(true)
	}
	const phoneNumberOnChange = (newValue: string) => {
		setPhoneNumber(newValue)
		setValueChanged(true)
	}
	const countryOnChange = (newValue: string) => {
		setCountry(newValue)
		setValueChanged(true)
	}
	const genderOnChange = (newValue: string) => {
		setGender(newValue)
		setValueChanged(true)
	}

	const languageOnChange = (newValue: string) => {
		let indexOfValue: string = `${LANGUAGES.indexOf(newValue)}`
		let languagesArr: string[] = []
		let removedLanguage: boolean = false
		if (languages) {
			const currentLangsArr: string[] = languages?.split(',')
			currentLangsArr.forEach((langId: string) => {
				if (langId === indexOfValue) {
					removedLanguage = true
				} else {
					languagesArr.push(langId)
				}
			})
		}
		if (removedLanguage === false) {
			languagesArr.push(indexOfValue)
		}
		setLanguages(languagesArr.join(','))
		setValueChanged(true)
	}

	const terrainsOnChange = (newValue: string) => {
		let indexOfValue: string = `${TERRAINS.indexOf(newValue)}`
		let terrainsArr: string[] = []
		let removedTerrain: boolean = false
		if (terrains) {
			const currentTerrainArr: string[] = terrains?.split(',')
			currentTerrainArr.forEach((id: string) => {
				if (id === indexOfValue) {
					removedTerrain = true
				} else {
					terrainsArr.push(id)
				}
			})
		}
		if (removedTerrain === false) {
			terrainsArr.push(indexOfValue)
		}
		setTerrains(terrainsArr.join(','))
		setValueChanged(true)
	}

	const levelOnChange = (newValue: string) => {
		setLevel(newValue)
		// userStateData.setStatus(AccountStatus.ACTIVE)
		// setAccountStatus(AccountStatus.ACTIVE)
		setValueChanged(true)
	}

	const statusOnChange = (newValue: string) => {
		setAccountStatus(newValue)
		setValueChanged(true)
	}

	const bankCountryOnChange = (newValue: string) => {
		setBankCountry(newValue)
		setValueChanged(true)
	}

	const aboutTextOnChange = (newValue: string) => {
		setAboutText(newValue)
		setValueChanged(true)
	}

	// ================================================ DOB STUFF ===========================================
	// const onDobDateChange = (newValue: string) => {
	// 	setDobDate(parseInt(newValue))
	// 	setValueChanged(true)
	// }
	// const onDobMonthChange = (newValue: string) => {
	// 	setDobMonth(parseInt(newValue))
	// 	setValueChanged(true)
	// }
	const onDobDateChange = (newValue: string) => {
		// setDobDate(parseInt(newValue))
		setDobDate(newValue)
		setValueChanged(true)
	}
	const onDobMonthChange = (newValue: string) => {
		// setDobMonth(parseInt(newValue))
		setDobMonth(newValue)
		setValueChanged(true)
	}
	const onDobYearChange = (newValue: string) => {
		setDobYear(parseInt(newValue))
		setValueChanged(true)
	}

	// ================================================ BANK ================================================

	const bankNameOnChange = (newValue: string) => {
		setBankName(newValue)
		setValueChanged(true)
	}
	const accountOnChange = (newValue: string) => {
		setAccount(newValue)
		setValueChanged(true)
	}
	const sortCode1Change = (newValue: string) => {
		const splitValues: string[] = newValue.split('')
		let formedString: string = ''
		splitValues.forEach((char: string) => {
			if (!Number.isNaN(parseInt(newValue))) {
				if (formedString.length < 2) {
					formedString = formedString + char
				}
			}
		})
		setSortCode1(formedString)
		setValueChanged(true)
	}
	const sortCode2Change = (newValue: string) => {
		const splitValues: string[] = newValue.split('')
		let formedString: string = ''
		splitValues.forEach((char: string) => {
			if (!Number.isNaN(parseInt(newValue))) {
				if (formedString.length < 2) {
					formedString = formedString + char
				}
			}
		})
		setSortCode2(formedString)
		setValueChanged(true)
	}
	const sortCode3Change = (newValue: string) => {
		const splitValues: string[] = newValue.split('')
		let formedString: string = ''
		splitValues.forEach((char: string) => {
			if (!Number.isNaN(parseInt(newValue))) {
				if (formedString.length < 2) {
					formedString = formedString + char
				}
			}
		})
		setSortCode3(formedString)
		setValueChanged(true)
	}
	const swiftBicOnChange = (newValue: string) => {
		setSwiftBic(newValue)
		setValueChanged(true)
	}
	const priceOnChange = (newValue: string) => {
		// if (Number(newValue) < MIN_PRICE) {
		// 	setPrice(MIN_PRICE.toFixed(2))	
		// } else if (Number(newValue) > MAX_PRICE) {
		// 	setPrice(MAX_PRICE.toFixed(2))
		// } else {
		// 	// setPrice(Number(newValue).toFixed(2))
		// 	setPrice(newValue)
		// }
		setPrice(newValue)
		setValueChanged(true)
	}
	const onPriceBlur = () => {
		if (price && level) {
			setPrice(getStringWithinRange(price, 0, MAX_PRICES[Number(level)]))
		}
	}
	

	// ================================================ USER DATA ===========================================

	const setUserData = () => {
		if (accountStatus) {
			userStateData.setStatus(accountStatus)
		}
		userStateData.setName(yourName)
		userStateData.setCountry(country)
		userStateData.setPhoneNumber(phoneNumber)
		userStateData.setGender(gender)
		userStateData.setLanguages(languages)
		userStateData.setTerrains(terrains)
		if (dobDate && dobMonth && dobYear) {
			// userStateData.setDob(dobDate, dobMonth, dobYear)
			// userStateData.setDob(parseInt(dobDate), parseInt(dobMonth), dobYear)
			userStateData.setDob(parseInt(dobDate), parseInt(dobMonth) - 1, dobYear)
		}
		userStateData.setBankCountry(bankCountry)
		userStateData.setBankName(bankName)
		userStateData.setBankAccountNumber(account)
		if (sortCode1 && sortCode2 && sortCode3) {
			userStateData.setBankSortCode(`${sortCode1}-${sortCode2}-${sortCode3}`)
		} else {
			userStateData.setBankSortCode(undefined)
		}
		userStateData.setBankSwiftBic(swiftBic)
		userStateData.setAboutText(aboutText)
		if (level) {
			userStateData.setLevel(level)
		}
	}

	const getStringWithinRange = (value: string, min_value: number, max_value: number): string => {
		if (Number(value) < min_value) {
			return min_value.toFixed(2)
		} else if (Number(value) > max_value) {
			return max_value.toFixed(2)
		} else {
			return Number(value).toFixed(2)
		}
	}

	const updateDataOnClick = () => {
		setUpdatingUserData(true)
		setValueChanged(false)

		setUserData()

		if (updateConnector.requestInProgress) {
			console.log('[DashboardInstructorProfileContentArea] - updateDataOnClick() called while requestInProgress')
		} else {
			updateConnector.updateInstructorDataRequest(userStateData.getId()).then((successRequest) => {
				setUpdatingUserData(false)
				if (!successRequest) {
					console.log('WARNING - [DashboardInstructorProfileContentArea] - updateDataOnClick() failed')
				} else {
					updateUserValues()
					// window.location.replace(PAGE_URLS.DASHBOARD_CUSTOMER)
				}
			})
		}
	}

	const toggleActiveState = () => {
		userStateData.toggleSuspendedState()
		setAccountStatus(userStateData.getStatus())
		setValueChanged(true)
	}

	return (
		<div className='dashboard-content-area-wrap'>
			{userDataLoaded &&
				<>
					<div className='dashboard-content-area-wide-card-wrap'>
						<div className='dashboard-profile-section-wrap'>
							{profilePicUrls && profilePicUrls.length > 0 &&
								<div className='dashboard-profile-instructor-profile-img-content'>
									{profilePicUrls.map((picUrl: string, index: number) =>
										<div
											className='dashboard-profile-profile-img-wrap'
											key={`profileImg${index}`}
										>
											<div className='dashboard-profile-instructor-profile-img-wrap'>
												<img
													className='dashboard-profile-instructor-profile-img'
													src={`${PROFILE_PIC_URL}${picUrl}`}
													alt='Profile'
												/>
											</div>
										</div>
									)}
								</div>
							}
						</div>
						<div className='dashboard-instructor-profile-section-wrap'>
							<div className='dashboard-instructor-profile-section-main-title'>
								Instructor {yourName}
							</div>
							<div className='dashboard-instructor-profile-section-main-sub-title'>
								{userStateData.getEmail()}
							</div>
							{/* <div className='dashboard-instructor-profile-section-main-sub-title'>
								Status "{userStateData.getStatusMessage()}"
								{(accountStatus === AccountStatus.ACTIVE || accountStatus === AccountStatus.BANNED) &&
									<label className="dashboard-instructor-profile-switch">
										<input
											type="checkbox"
											checked={accountStatus === AccountStatus.ACTIVE}
											onClick={() => {
												toggleActiveState()
											}}
										/>
										<span className="dashboard-instructor-profile-slider round"></span>
									</label>
								}
							</div> */}
							<div className='dashboard-instructor-profile-input-wrap'>
								<LabeledDropDown
									label='STATUS'
									onChange={statusOnChange}
									value={accountStatus}
									options={STATUS_OPTIONS}
									disabled={updatingUserData}
								/>
							</div>
							{level &&
								<div className='dashboard-instructor-profile-section-level-wrap'>
									<div className={`dashboard-profile-instructor-level dashboard-profile-instructor-level-${level}`}>Level {level}</div>
								</div>
							}
							<div className='dashboard-instructor-profile-section-title'>
								About You
							</div>
							<div className='dashboard-instructor-profile-input-wrap dashboard-instructor-profile-input-wrap-double'>
								<LabeledInput
									label='Your Name'
									onChange={yourNameOnChange}
									value={yourName}
									disabled={updatingUserData}
								/>
								<LabeledInput
									label='Phone Number'
									onChange={phoneNumberOnChange}
									value={phoneNumber}
									disabled={updatingUserData}
								/>
							</div>
							<div className='dashboard-instructor-profile-input-wrap dashboard-instructor-profile-input-wrap-double'>
								<LabeledInput
									label='Country'
									onChange={countryOnChange}
									value={country}
									disabled={updatingUserData}
								/>
								<LabeledDropDown
									label='Gender'
									onChange={genderOnChange}
									value={gender}
									options={INSTRUCTOR_GENDERS}
									disabled={updatingUserData}
								/>
							</div>
							<div className='dashboard-instructor-profile-section-sub-title'>
								Date of Birth
							</div>
							<div className='dashboard-instructor-profile-input-wrap'>
								<LabeledDropDown
									label='Date'
									options={Array.from({ length: 31 }, (_, i) => `${i + 1 < 10 ? `0${i + 1}` : i + 1}`)}
									onChange={onDobDateChange}
									value={`${dobDate}`}
									disabled={updatingUserData}
								/>
								<LabeledDropDown
									label='Month'
									options={Array.from({ length: 12 }, (_, i) => `${i + 1 < 10 ? `0${i + 1}` : i + 1}`)}
									onChange={onDobMonthChange}
									// value={dobMonth ? dobMonth < 10 ? `0${dobMonth}` : `${dobMonth}` : undefined}
									value={dobMonth}
									disabled={updatingUserData}
								/>
								<LabeledDropDown
									label='Year'
									options={Array.from({ length: 50 }, (_, i) => `${i + 2025 - 15 - 50}`)}
									onChange={onDobYearChange}
									value={`${dobYear}`}
									disabled={updatingUserData}
								/>
							</div>
							<div className='dashboard-instructor-profile-input-wrap'>
								<LabeledTextArea
									label='About You Message'
									value={aboutText}
									onChange={aboutTextOnChange}
									disabled={updatingUserData}
								/>
							</div>
							<div className='dashboard-instructor-profile-section-title'>
								Skills & Preferences
							</div>
							<div className='dashboard-instructor-profile-input-wrap dashboard-instructor-profile-input-wrap-margin'>
								{
									idFilePath ?
										<div className='dashboard-instructor-profile-section-sub-title'>
											Id - <a
												href={`${DOCUMENT_FILE_PATH}${idFilePath}`}
												target='_blank'
											>Open</a>
										</div>
										:
										<div className='dashboard-instructor-profile-section-sub-title'>
											No Id Provided
										</div>
								}
							</div>
							<div className='dashboard-instructor-profile-input-wrap dashboard-instructor-profile-input-wrap-margin'>
								{
									certificateFilePath ?
										<>
											
											<div className='dashboard-instructor-profile-section-sub-title'>
												Certificate proof - <a
													href={`${DOCUMENT_FILE_PATH}${certificateFilePath}`}
													target='_blank'
												>Open</a>
											</div>
										</>
										:
										<div className='dashboard-instructor-profile-section-sub-title'>
											No Certificate Provided
										</div>
								}
							</div>
							<div className='dashboard-instructor-profile-input-wrap'>
								<LabeledDropDown
									label='Level'
									onChange={levelOnChange}
									value={level}
									options={['1','2','3','4']}
									disabled={updatingUserData}
									blankValue='Level Not Set'
								/>
							</div>
							<div className='dashboard-instructor-profile-input-wrap'>
								<LabeledInput
									// label={`Price Level 1 (NZD) ${MIN_PRICE.toFixed(2)} - ${MAX_PRICE.toFixed(2)}`}
									label={`Price (NZD) ${MIN_PRICE.toFixed(2)} - ${MAX_PRICES[Number(level)].toFixed(2)}`}
									onChange={priceOnChange}
									value={price}
									onBlur={onPriceBlur}
									disabled={updatingUserData}
								/>
							</div>
							<div className='dashboard-instructor-profile-input-wrap'>
								<LabeledDropDown
									label='Languages'
									onChange={languageOnChange}
									value={undefined}
									options={LANGUAGES}
									disabled={updatingUserData}
									keepBlank={true}
									blankValue='Add Language'
								/>
							</div>
							{languages && languages.length > 0 &&
								<div className='dashboard-instructor-profile-input-wrap dashboard-instructor-profile-list-wrap'>
									{languages.split(',').map((langaugeIndex: string, langIndex: number) =>
										<div
											className='dashboard-instructor-profile-list-value'
											key={`langValue${langIndex}`}
										>
											<img
												src='/imgs/icons/dashboard/icon-delete-x.svg'
												alt='remove language'
												className='dashboard-instructor-profile-list-value-remove-button'
												onClick={() => {
													languageOnChange(LANGUAGES[parseInt(langaugeIndex)])
												}}
											/>
											{LANGUAGES[parseInt(langaugeIndex)]}
										</div>
									)}
								</div>
							}
							<div className='dashboard-instructor-profile-input-wrap'>
								<LabeledDropDown
									label='Preferred Terrain'
									onChange={terrainsOnChange}
									value={undefined}
									options={TERRAINS}
									disabled={updatingUserData}
									keepBlank={true}
									blankValue='Add Terrain'
								/>
							</div>
							{terrains && terrains.length > 0 &&
								<div className='dashboard-instructor-profile-input-wrap dashboard-instructor-profile-list-wrap'>
									{terrains.split(',').map((terrainIndex: string, listIndex: number) =>
										<div
											className='dashboard-instructor-profile-list-value'
											key={`terrainValue${listIndex}`}
										>
											<img
												src='/imgs/icons/dashboard/icon-delete-x.svg'
												alt='remove terrain'
												className='dashboard-instructor-profile-list-value-remove-button'
												onClick={() => {
													terrainsOnChange(TERRAINS[parseInt(terrainIndex)])
												}}
											/>
											{TERRAINS[parseInt(terrainIndex)]}
										</div>
									)}
								</div>
							}
							<div className='dashboard-instructor-profile-section-title'>
								Bank Details
							</div>
							<div className='dashboard-instructor-profile-input-wrap'>
								<LabeledDropDown
									label='Bank Country'
									onChange={bankCountryOnChange}
									value={bankCountry}
									options={BANK_COUNTRIES}
									disabled={updatingUserData}
									keepBlank={true}
									blankValue='Choose Country'
								/>
							</div>
							{bankCountry &&
								<>
									<div className='dashboard-instructor-profile-input-wrap'>
										<LabeledInput
											label='Account Holder Name'
											onChange={bankNameOnChange}
											value={bankName}
											disabled={updatingUserData}
										/>
									</div>
									<div className='dashboard-instructor-profile-input-wrap'>
										<LabeledInput
											label='Account Number'
											onChange={accountOnChange}
											value={account}
											type='number'
											disabled={updatingUserData}
										/>
									</div>
								</>
							}
							{bankCountry === 'UK' &&
								<>
									<div className='dashboard-instructor-profile-section-sub-title'>
										Sort Code
									</div>
									<div className='dashboard-instructor-profile-input-wrap dashboard-instructor-profile-input-wrap-triple'>
										<LabeledInput
											onChange={sortCode1Change}
											value={sortCode1}
											// type='number'
											disabled={updatingUserData}
										/>
										<div className='dashboard-instructor-sort-code-seperator'>-</div>
										<LabeledInput
											onChange={sortCode2Change}
											value={sortCode2}
											// type='number'
											disabled={updatingUserData}
										/>
										<div className='dashboard-instructor-sort-code-seperator'>-</div>
										<LabeledInput
											onChange={sortCode3Change}
											value={sortCode3}
											// type='number'
											disabled={updatingUserData}
										/>
									</div>
								</>
							}
							{bankCountry === 'New Zealand' &&
								<div className='dashboard-instructor-profile-input-wrap'>
									<LabeledInput
										label='Swift/Bic'
										onChange={swiftBicOnChange}
										value={swiftBic}
										type='number'
										disabled={updatingUserData}
									/>
								</div>
							}
						</div>
					</div>
					{valueChanged && 
						<>
							<div className='update-button-wrap-spacer' />
							<div className='update-button-wrap'>
								<CtaButton
									label='Update'
									onClick={() => updateDataOnClick()}
									size='medium'
									disabled={updatingUserData}
								/>
							</div>
						</>
					}
					{/* <div className='update-button-wrap'>
						<CtaButton
							label='Update'
							onClick={() => updateDataOnClick()}
							size='medium'
							disabled={uploadingImage || uploadingDocument || updatingUserData || valueChanged === false}
						/>
					</div> */}
				</>
			}
		</div>
	)
}

export default AdminInstructorProfileContentArea
